export default __webpack_public_path__ + "static/media/wedding_guest.16394ef1.svg";